/**
 * Passing 2 array of objects, this function will return the intersection of the 2 arrays
 * based on the property passed as a parameter.
 * @param {*} array1
 * @param {*} array2
 * @param {*} field field used in to compare the objects of the arrays
 * @returns
 */
export const intersectionBy = (
  array1, array2, field
) => {
  return array1.filter((item) => array2.find((item2) => item2[field] === item[field]));
};

/**
 * Passing 2 array of objects, this function will return the intersection of the 2 arrays
 * using the compare function passed
 * @param {*} array1
 * @param {*} array2
 * @param {*} compareFn function used to compare the objects of the arrays
 * @returns
 */
export const intersectionWith = (
  array1, array2, compareFn
) => {
  return array1.filter((item) => array2.find((item2) => compareFn(item, item2)));
};

/**
 * Passing 1 array of object and 1 field, this function will return the array of objects
 * ordered based on the field passed and type of order passed (asc or desc)
 * @param {*} array of objects
 * @param {*} field used to order the objects
 * @param {*} asc true if the order is ascending, false otherwise
 */
export const orderBySingleField = (
  array, field, asc = true
) => {
  return array.sort((a, b) => {
    if (a[field] > b[field]) return asc ? 1 : -1;
    if (a[field] < b[field]) return asc ? -1 : 1;
    return 0;
  });
};

export const areEqualArray = (array1, array2) => {
  if (array1.length === array2.length) {
    return array1.every((element, index) => {
      if (element === array2[index]) {
        return true;
      }

      return false;
    });
  }

  return false;
};